import {
  createCookie,
  isCurrentPageInList,
  loadJs,
  setPaymentAndSubscriptionStatus,
} from '@components/common';
import {
  Debuger_Script_URLS,
  ECOM_WIDGET_URLS,
} from '@components/common/constant';
import ErrorBoundary from '@components/errorBoundry';
import { GlobalContextProvider } from '@components/globalContext';
import { Layout } from '@components/layout';
import { ThemeWrapper } from '@license-admin/boldfjcomponents';
import { CreateTheme } from '@styles/styles';
import { getENVPath } from 'helper';
import {
  getUserID,
  getUsersAllExperimentAndUpdateCookie,
  SyncMixpanel,
} from 'helper/experiments/experimentActions';
import Head from 'next/head';
// import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect, useState } from 'react';
declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    TS: any;
    APP: any;
    sendBannerEvent: any;
  }
}

function setCDNExpCookie() {
  if (
    (getENVPath().NEXT_PUBLIC_APP_ENV !== undefined &&
      getENVPath().NEXT_PUBLIC_APP_ENV) !== 'prod'
  ) {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const eID = searchParams.get('eID'); // Get single value
    const vID = searchParams.get('vID');
    // add cookie
    let cdnCookieFormat = 'eID_vID_1_0_rmc_100325';
    if (eID && vID) {
      cdnCookieFormat = cdnCookieFormat?.replace('eID', eID);
      cdnCookieFormat = cdnCookieFormat?.replace('vID', vID);
      createCookie('ew_exp', cdnCookieFormat);
    }
  }
}

function App({ Component, pageProps }: any) {
  const router = useRouter();
  const [themeType, setThemeType] = useState(
    pageProps.themeType || getENVPath().NEXT_PUBLIC_THEME
  );
  useEffect(() => {}, []);

  const theme = CreateTheme(themeType);
  const [isDOMLoaded, setIsDOMLoaded] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.document) {
      const handleLoad = () => {
        setIsDOMLoaded(true);
        setPaymentAndSubscriptionStatus();
        SyncMixpanel();

        pageProps.deviceType === 'mobile' &&
          isCurrentPageInList(router, Debuger_Script_URLS) &&
          loadJs(`https://cdn.debugbear.com/Ey5GNaVl1Fiv.js`);

        isCurrentPageInList(router, ECOM_WIDGET_URLS) &&
          loadJs(`/payment/scripts/rmc/sellPrefetchScript.js`);
      };

      if (document.readyState === 'complete') {
        handleLoad();
      } else {
        window.addEventListener('load', handleLoad);
      }
      setCDNExpCookie();

      return () => {
        window.removeEventListener('load', handleLoad);
      };
    }
    const userID = getUserID();
    if (userID !== null) {
      getUsersAllExperimentAndUpdateCookie(userID, document.cookie);
    }
    // Cleanup event listener on component unmount
  }, []);

  const handleThemeChange = (event: React.FormEvent<HTMLSelectElement>) => {
    if (event.currentTarget.value !== 'default') {
      setThemeType(event.currentTarget.value.toLowerCase());
      createCookie('theme', event.currentTarget.value.toLowerCase());
    }
  };

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <ThemeWrapper setThemeType={themeType} getTheme={theme.MainTheme}>
        {pageProps.deviceType !== 'mobile' && <theme.BaseFont />}
        <theme.GlobalCSS />
        <GlobalContextProvider>
          <ErrorBoundary>
            <Layout
              {...pageProps}
              handleThemeChange={handleThemeChange}
              isHomePageHeader={false}
            >
              <Component {...pageProps} />
            </Layout>
          </ErrorBoundary>
        </GlobalContextProvider>
      </ThemeWrapper>
      {isDOMLoaded && (
        <Script
          src={'/blobcontent/rmc/externals/app.js'}
          id="app-js"
          strategy="afterInteractive"
          defer
        />
      )}
    </>
  );
}

export default App;
